<template>
    <ul class="news">
       <li v-for="(item,index) in news">
         <router-link :to="'/news/'+item.infoId">{{item.infoTitle}}<span class="time-box">{{item.infoDt|time}}</span></router-link>
       </li>
    </ul>
</template>
<script>
  import dateFormate from '../../../uitil/dateFormat'
    export default{
        data(){
            return {}
        },
        props: {
            news:{
                type: Array
            }
        },
        methods: {
        },
      filters:{
        time(time){
          return dateFormate(time);
        }
      }

    }
</script>
<style scoped>
.news{
  font-size: 14px;
  padding: 0 15px;
}
  li{
    /*border-bottom: 1px solid #eee;*/
    line-height: 28px;
  }
  li span{
    margin-left: 20px;
  }
  .time-box{
    display: inline-block;
    width: 200px;
    text-align: left;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// iNews.vue?14e7f3a0